import AppHeader from "@/components/AppHeader";

export default {
  name: "master-position",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompany();
    await this.getPosition();
  },
  data() {
    return {
      companies: "",
      positions: [],
      selectedCompany: localStorage.company_id,
      getCompanisEnd: false,
      getPositionsEnd: false,
      deletePositionId: "",
      errorInfo: ""
    };
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getPosition() {
      this.getPositionsEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_POSITION", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.positions = res.positions;
      this.getPositionsEnd = true;
    },
    goPositionEdit(positionId) {
      this.$router.push({ path: `/master_position/${positionId}/edit` });
    },
    deleteModal(positionId) {
      this.deletePositionId = positionId;
      this.$bvModal.show("modal-delete");
    },
    async deletePosition() {
      let res = await this.$store
        .dispatch("DELETE_POSITION", {
          id: this.deletePositionId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getPosition();
        this.$bvModal.hide("modal-delete");
      } else {
        this.errorInfo = res.error;
        this.$bvModal.hide("modal-delete");
        this.$bvModal.show("modal-error");
      }
    }
  }
};
